import { ReactNode, useMemo } from 'react';

import { ApolloClient, InMemoryCache } from '@apollo/client';
import { Defer20220824Handler } from '@apollo/client/incremental';
import { LocalState } from '@apollo/client/local-state';
import { ApolloProvider as Provider } from '@apollo/client/react';

import { environment } from '@anyx/app-core/env';

import { useAuthCtx } from '@anyx/common-auth';
import { possibleFragmentTypes } from '@anyx/common-graphql';
import { Environment } from '@anyx/shared-utils';



import { getApolloLink } from './apolloLink';
import { typePolicies } from './typePolicies';

/*
Start: Inserted by Apollo Client 3->4 migration codemod.
Copy the contents of this block into a `.d.ts` file in your project to enable correct response types in your custom links.
If you do not use the `@defer` directive in your application, you can safely remove this block.
*/

import '@apollo/client';

export function ApolloProvider({ children }: { children: ReactNode }) {
  const { silentLogin } = useAuthCtx();

  const client = useMemo(
    () =>
      new ApolloClient({
        link: getApolloLink({ silentLogin }),

        cache: new InMemoryCache({
          possibleTypes: possibleFragmentTypes.possibleTypes,
          typePolicies: typePolicies,
        }),

        defaultOptions: {
          watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'all',
          },
        },

        /*
        Inserted by Apollo Client 3->4 migration codemod.
        If you are not using the `@client` directive in your application,
        you can safely remove this option.
        */
        localState: new LocalState({}),

        devtools: {
          enabled: environment.env !== Environment.PRODUCTION,
        },

        /*
        Inserted by Apollo Client 3->4 migration codemod.
        If you are not using the `@defer` directive in your application,
        you can safely remove this option.
        */
        incrementalHandler: new Defer20220824Handler(),
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <Provider client={client}>{children}</Provider>;
}

/*
End: Inserted by Apollo Client 3->4 migration codemod.
*/
